import React from "react"
import "./about.css"
import Back from "../common/back/Back"
import AboutCard from "./AboutCard"
import SEO from "../common/SEO"
import Hblog from "../home/Hblog"

const About = () => {
  return (
    <>
      <SEO
        title="About Us - Leading Education Consultancy"
        description="Learn about WELSH EDUCATION GROUP's mission to help students achieve their international education dreams. Our experienced team provides comprehensive education consultancy services."
        keywords="about us, education consultancy, international education, student services, WELSH EDUCATION GROUP team"
        url="/about"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "About WELSH EDUCATION GROUP",
          "description": "Leading education consultancy for international students",
          "url": "https://welsheducation.com/about",
          "mainEntity": {
            "@type": "EducationalOrganization",
            "name": "WELSH EDUCATION GROUP",
            "description": "Premier education consultancy"
          }
        }}
      />
      <Back title='About Us' showImages={true} />
      <AboutCard />
      <Hblog />
    </>
  )
}

export default About
